import React from 'react';
import ImageDownloadButton from 'components/Meteorology/Fields/ImageDownloadButton';

export default function Toolbar({
  onDownloadClick,
  downloadDisabled,
}: {
  onDownloadClick: () => void,
  downloadDisabled: boolean,
}) {
  return (
    <div className="d-flex justify-content-end">
      <ImageDownloadButton onClick={onDownloadClick} disabled={downloadDisabled} />
    </div>
  );
}
